module.exports = __webpack_public_path__ + "static/media/decorator.323df396.png";